import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/styles/index.scss' // global css
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

// 字典数据组件
import DictData from '@/components/DictData'
// 分页组件
import Pagination from "@/components/Pagination";
import Model from "@/views/components/modal";
// 文件上传组件
import FileUpload from "@/components/FileUpload"
import { getConfigKey } from "@/utils/api";

Vue.prototype.getConfigKey = getConfigKey
DictData.install()
Vue.use(ElementUI);


Vue.component('Pagination', Pagination)
Vue.component('Model', Model)
Vue.component('FileUpload', FileUpload)


new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
}).$mount('#app')
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
})